<template>
  <section
    id="home-nav"
    :class="[
      'home-nav sticky-element sticky-element-start card display-none tablet:display-none laptop:display-flex flex-wrap align-center tablet:align-between',
      { 'is-stuck with-shadow': isStickyElementStuck }
    ]"
    style="
      --link-decoration-line: none;
      --with-shadow-box-shadow-width: var(--spacing-3xs);
      --card-horizontal-padding: var(--spacing-3xl);
      --card-vertical-padding: var(--spacing-xl);
      --with-shadow-box-shadow: 0 var(--with-shadow-box-shadow-width) 0 var(--card-link-box-shadow-color)
      gap-x: var(--spacing-sm); z-index: var(--depth-2);
    "
  >
    <div>
      <site-link
        :to="{ hash: '#fa7' }"
        class="display-block margin-xs laptop:margin-0 margin-xs no-underline"
      >
        <font-awesome-icon
          :icon="$v7.solid.faSparkles"
          class="margin-right-4xs"
          size="lg"
        />
        Font Awesome 7
      </site-link>
    </div>
    <div>
      <site-link
        :to="{ hash: '#pro-plus' }"
        class="display-block margin-xs laptop:margin-0 no-underline"
      >
        <font-awesome-icon
          :icon="$v7.solid.faShapes"
          class="display-inline-block margin-right-4xs"
          size="lg"
        />
        New Icon Packs
      </site-link>
    </div>
    <div>
      <site-link
        :to="{ hash: '#tech' }"
        class="display-block margin-y-xs margin-x-xs tablet:margin-y-0 tablet:margin-x-0 no-underline"
      >
        <font-awesome-icon
          :icon="$v7.solid.faWrenchSimple"
          class="display-inline-block margin-right-4xs"
          size="lg"
        />
        Tech Updates
      </site-link>
    </div>
    <div>
      <site-link
        :to="{ hash: '#styling' }"
        class="display-block margin-y-xs margin-x-xs tablet:margin-y-0 tablet:margin-x-0 no-underline"
      >
        <font-awesome-icon
          :icon="$v7.solid.faPalette"
          class="display-inline-block margin-right-4xs"
          size="lg"
        />
        Styling Toolkit
      </site-link>
    </div>
    <div>
      <site-link
        :to="{ hash: '#pro-vs-pro-plus' }"
        class="display-block margin-y-xs margin-x-xs tablet:margin-y-0 tablet:margin-x-0 no-underline"
      >
        <font-awesome-icon
          :icon="$v7.solid.faRightLeft"
          class="display-inline-block margin-right-4xs"
          size="lg"
        />
        Pro vs Pro+
      </site-link>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'HomeNav',

    props: {
      isStickyElementStuck: {
        type: Boolean,
        required: true
      }
    }
  }
</script>
